/** Global layout: sidebar, top-bar, navigation labels, breadcrumbs. */
export const nav = {
  // Primary sidebar navigation labels (app-layout.tsx).
  items: {
    dashboard: "Dashboard",
    sites: "Sites",
    audiences: "Audiences",
    library: "Library",
    playlists: "Playlists",
    scheduling: "Scheduling",
    reports: "Reports",
    adRental: "Ad rental",
    team: "Team",
    billing: "Billing",
    settings: "Settings",
    support: "Support",
  },

  // Library sub-navigation (per-channel labels shown under Library).
  library: {
    music: "Music",
    announcements: "Announcements",
    ads: "Ads",
    screen: "Screen",
  },

  // Shell actions shared across app / control / standalone headers.
  shell: {
    switchWorkspace: "Switch Workspace",
    switchWorkspaceTitle: "Switch workspace",
    switchMode: "Switch Mode",
    switchModeTitle: "Switch mode",
    signOut: "Sign Out",
    signOutTitle: "Sign out",
    switchPlayer: "Switch player",
    account: "Account",
    mobileNav: "Navigation",
  },

  // Control-panel player header connection badge (control-header.tsx).
  control: {
    status: {
      live: "Live",
      connecting: "Connecting",
    },
  },

  // Mobile page/panel chrome (mobile-page-panel.tsx).
  pagePanel: {
    filtersAndActions: "Filters & actions",
    openNav: "Open navigation menu",
  },

  // Workspace switcher dropdown + create dialog (workspace-switcher.tsx).
  workspaceSwitcher: {
    fallbackName: "Workspace",
    menuLabel: "Workspaces",
    allWorkspaces: "All workspaces",
    createWorkspace: "Create workspace",
    createDescription:
      "A workspace groups your locations, devices, and team members.",
    nameLabel: "Workspace name",
    namePlaceholder: "e.g. Downtown Stores",
  },

  // Generic UI-primitive chrome (breadcrumb / carousel / dialog / pagination /
  // sheet / sidebar / spinner). Screen-reader labels and control captions.
  ui: {
    loading: "Loading",
    more: "More",
    morePages: "More pages",
    breadcrumb: {
      label: "breadcrumb",
    },
    carousel: {
      label: "carousel",
      slide: "slide",
      previousSlide: "Previous slide",
      nextSlide: "Next slide",
    },
    pagination: {
      label: "pagination",
      goToPrevious: "Go to previous page",
      goToNext: "Go to next page",
    },
    sidebar: {
      toggle: "Toggle Sidebar",
      title: "Sidebar",
      description: "Displays the mobile sidebar.",
    },
  },
} as const;
